var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useMutation, useQuery } from 'react-query';
import { TicketModel, TicketHistoryModel } from 'renderer/models';
import { RestClient, usePager } from 'renderer/utils';
import { QUERY_CACHE } from 'renderer/queries';
import { CustomerPointModel } from '../models/CustomerPointModel';
// for QR
export var createTicketHistoryForQR = function (payload) {
    return RestClient.getInstance()
        .post("/ticket/history", payload)
        .then(function (response) {
        return new TicketModel(response.data);
    });
};
export var getStoreTicketByIdForQR = function (id) {
    return RestClient.getInstance()
        .get("ticket/".concat(id, "/details"))
        .then(function (response) {
        return new TicketModel(response.data);
    });
};
export var getTicketByTokenForQR = function (token) {
    return RestClient.getInstance()
        .get("external/ticket/".concat(token))
        .then(function (response) {
        return new TicketModel(response.data);
    });
};
export var checkCustomerPasswordForQR = function (customerId, password) {
    return RestClient.getInstance()
        .post("external/customer/".concat(customerId, "/login"), { password: password })
        .then(function (response) {
        return response.data;
    });
};
export var updateCustomerPasswordForQR = function (customerId, password) {
    return RestClient.getInstance()
        .put("external/customer/".concat(customerId), { password: password })
        .then(function (response) {
        return response.data;
    });
};
// for QR
var getAllTicketsByStoreId = function (options) {
    var _a = options.queryKey, _ = _a[0], params = _a[1];
    var storeId = params.storeId, rest = __rest(params, ["storeId"]);
    return RestClient.getInstance()
        .get("/stores/".concat(storeId, "/tickets"), {
        params: rest
    })
        .then(function (result) { return result.data; });
};
var getTicketHistoryByTicketId = function (options) {
    var _a = options.queryKey, _ = _a[0], params = _a[1];
    var storeId = params.storeId, rest = __rest(params, ["storeId"]);
    return RestClient.getInstance()
        .get("/stores/".concat(storeId, "/tickets/history"), {
        params: rest
    })
        .then(function (result) { return result.data; });
};
var createPointHistory = function (payload) {
    return RestClient.getInstance()
        .post("/stores/".concat(payload.storeId, "/tickets/customer-point"), payload)
        .then(function (result) { return new CustomerPointModel(result.data); });
};
var updatePointHistory = function (payload) {
    return RestClient.getInstance()
        .put("/stores/".concat(payload.storeId, "/tickets/customer-point"), payload)
        .then(function (result) { return new CustomerPointModel(result.data); });
};
var bulkUpdatePointExpiration = function (_a) {
    var storeId = _a.storeId, expiredOption = _a.expiredOption;
    return RestClient.getInstance()
        .put("/stores/".concat(storeId, "/tickets/customer-point/expiration"), { expiredOption: expiredOption })
        .then(function (result) { return new CustomerPointModel(result.data); });
};
var createTicket = function (payload) {
    return RestClient.getInstance()
        .post("/stores/".concat(payload.storeId, "/tickets"), payload)
        .then(function (result) { return new TicketModel(result.data); });
};
var updateTicket = function (payload) {
    return RestClient.getInstance()
        .put("/stores/".concat(payload.storeId, "/tickets"), payload)
        .then(function (result) { return new TicketModel(result.data); });
};
var deleteTicket = function (params) {
    return RestClient.getInstance()
        .remove("/stores/".concat(params.storeId, "/tickets").concat(params.id))
        .then(function (result) { return new TicketModel(result.data); });
};
var mutationConfig = {
    onSuccess: function (data, _) {
        // TODO: 필터에 맞춰서 optimise
        QUERY_CACHE.invalidateQueries(['tickets']);
        QUERY_CACHE.invalidateQueries(['totalPrepaidAndTicketAmountAndCustomerPoint']);
        QUERY_CACHE.invalidateQueries(['customers.detail']);
        // data가 다다를 건데??
        QUERY_CACHE.invalidateQueries(['customerPointHistory']);
        QUERY_CACHE.invalidateQueries(['ticketHistory']);
        if (data.customerId && data.storeId) {
            QUERY_CACHE.invalidateQueries(['customers', { id: data.customerId, storeId: data.storeId }]);
            QUERY_CACHE.invalidateQueries(['customerDetail', { id: data.customerId, storeId: data.storeId }]);
        }
        QUERY_CACHE.invalidateQueries(['storePoint']);
        QUERY_CACHE.invalidateQueries(['ticketsStatistics']);
    },
    onError: function (error) {
        // TODO: 필터에 맞춰서 optimise
    }
};
export var useTicketsByStoreId = function (params, config) {
    return usePager('tickets', params, getAllTicketsByStoreId, TicketModel, config);
};
export var useQueryTicketsByStoreId = function (params, config) {
    var queryKey = ['tickets'];
    if (params) {
        var storeId = params.storeId, rest = __rest(params, ["storeId"]);
        queryKey.push(String(storeId), JSON.stringify(rest));
    }
    return useQuery(__assign({ queryKey: queryKey, queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var storeId, rest, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(params === null || params === void 0 ? void 0 : params.storeId))
                            return [2 /*return*/, undefined];
                        storeId = params.storeId, rest = __rest(params, ["storeId"]);
                        return [4 /*yield*/, RestClient.getInstance().get("/stores/".concat(storeId, "/tickets"), { params: rest })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result === null || result === void 0 ? void 0 : result.data];
                }
            });
        }); } }, config));
};
export var useTicketHistory = function (params, config) {
    return usePager('ticketHistory', params, getTicketHistoryByTicketId, TicketHistoryModel, config);
};
export var useCreateCustomerPointHistory = function (config) {
    return useMutation(createPointHistory, __assign(__assign({}, mutationConfig), config));
};
export var useUpdateTicket = function (config) {
    return useMutation(updateTicket, __assign(__assign({}, mutationConfig), config));
};
export var useUpdateCustomerPointHistory = function (config) {
    return useMutation(updatePointHistory, __assign(__assign({}, mutationConfig), config));
};
export var useBulkUpdatePointHistoryExpiration = function (config) {
    return useMutation(bulkUpdatePointExpiration, __assign(__assign({}, mutationConfig), config));
};
var getTotalPrepaidAndTicketAmountAndCustomerPoint = function (options) {
    var storeId = options.queryKey[1];
    return RestClient.getInstance()
        .get("/stores/".concat(storeId, "/tickets/total"))
        .then(function (result) { return result.data; });
};
export var useTotalPrepaidAndTicketAmountAndCustomerPoint = function (storeId, config) {
    return useQuery(['totalPrepaidAndTicketAmountAndCustomerPoint', storeId], getTotalPrepaidAndTicketAmountAndCustomerPoint, config);
};
